<template>
    <div class="row recent-orders">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <h3>
                        {{
                            pageType != "dashboard"
                                ? "Invoices"
                                : "Recent Invoices"
                        }}
                    </h3>
                </div>
                <div
                    v-if="pageType != 'dashboard'"
                    class="col-sm-12 col-md-3 pb-2"
                >
                    <div class="row align-items-center">
                        <div class="col-md-3">
                            <label
                                class="form-control-label text-muted"
                                for="filter_status"
                                >Filter Status:
                            </label>
                        </div>
                        <div class="col-md-9">
                            <select
                                id="filter_status"
                                class="form-control"
                                v-model="searchStatus"
                                @change="selectStatus"
                            >
                                <option value="all">ALL</option>
                                <option value="open">Open</option>
                                <option value="closed">Closed</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-if="pageType != 'dashboard'"
                    class="col-sm-12 col-md-3 text-right"
                >
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Search Invoices"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="filterShow" class="filter-section">
                <div class="">By Status</div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 15em">Invoice Number</th>
                        <th style="width: 12em">PO Number</th>
                        <th style="width: 12em">Order #</th>
                        <th style="width: 10em">Invoice Date</th>
                        <th style="width: 10em">Due Date</th>
                        <th>Dealer</th>
                        <th class="text-right" style="width: 8em">Total</th>
                        <th class="text-right" style="width: 8em">
                            Amount Due
                        </th>
                        <th style="width: 7em"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="invoice in paginatedInvoices" :key="invoice.id">
                        <td class="hyperlink" @click="viewInvoice(invoice)">
                            <b v-if="user.is_demo">INV-12345</b>
                            <b v-else>{{ invoice.invoice_number }}</b>
                        </td>
                        <td
                            class="hyperlink"
                            @click="
                                viewOrder(
                                    invoice.invoice_origin,
                                    // invoice.order?.id
                                    invoice.order_id
                                )
                            "
                        >
                            <span
                                v-if="user.is_demo"
                                :class="
                                    invoice.invoice_origin?.substring(0, 2) ==
                                    'SO'
                                        ? 'font-weight-bold'
                                        : ''
                                "
                                >ORD-12345</span
                            >
                            <span
                                v-else
                                :class="
                                    invoice.reference?.substring(0, 2) == 'SO'
                                        ? 'font-weight-bold'
                                        : ''
                                "
                                >{{ invoice.reference }}</span
                            >
                        </td>
                        <td>
                            {{ invoice.order_id }}
                        </td>
                        <td>
                            {{ $filters.dateFormat2(invoice.invoice_date) }}
                        </td>
                        <td>{{ $filters.dateFormat2(invoice.due_date) }}</td>
                        <!-- <td>{{ invoice.location.name }}</td> -->
                        <td>{{ invoice.location_name }}</td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(invoice.total) }}
                        </td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(invoice.amount_due) }}
                        </td>
                        <td>
                            <span
                                class="px-1 view-action"
                                @click="viewInvoice(invoice)"
                                ><i class="fa fa-eye" aria-hidden="true"></i>
                                VIEW</span
                            >
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Pagination -->
            <table-pagination
                v-show="pageType != 'dashboard'"
                v-model="paginatedInvoices"
                :all-rows="searchAllInvoicesbyTerm"
                :perPage="perPage"
                @updateRow="updateRow"
            >
            </table-pagination>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import TablePagination from "@/components/TablePagination.vue";

export default {
    props: ["pageType", "pageType2"],
    emits: [],
    components: {
        TablePagination,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let allInvoices = computed(function () {
            return store.state.allInvoices;
        });
        // let filteredInvoices = computed(function () { return store.state.filteredInvoices });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let orderInfo = computed(function () {
            return store.state.orderInfo;
        });

        function getAllInvoices(currentLocation) {
            store.dispatch("getAllInvoices", {
                location_id: currentLocation.id,
            });
        }

        function setInvoiceInfo(invoice) {
            store.commit("setInvoiceInfo", invoice);
        }

        function searchInvoices(val) {
            store.dispatch("searchInvoices", val);
        }

        function getOrderByOrderNumber(orderNum) {
            store.dispatch("getOrderByOrderNumber", orderNum);
        }

        onMounted(() => {});

        return {
            store,
            user,
            allInvoices,
            // filteredInvoices,
            currentLocation,
            orderInfo,
            getAllInvoices,
            setInvoiceInfo,
            searchInvoices,
            getOrderByOrderNumber,
        };
    },
    data() {
        return {
            paginatedInvoices: [],
            perPage: this.pageType == "dashboard" && this.pageType2 ? 5 : 50,
            searchTerm: "",
            searchStatus: "all",
            filterShow: false,
        };
    },
    computed: {
        searchAllInvoicesbyTerm() {
            if (this.searchTerm === "" && this.searchStatus === "all") {
                return this.allInvoices;
            }

            var filterArr = [];
            var filterArr2 = [];
            var result = [];

            if (this.searchStatus !== "all") {
                this.allInvoices.forEach((invoice) => {
                    if (this.searchStatus == "open" && invoice.amount_due > 0) {
                        filterArr.push(invoice);
                    } else if (
                        this.searchStatus == "closed" &&
                        invoice.amount_due <= 0
                    ) {
                        filterArr.push(invoice);
                    }
                });
            }

            if (this.searchTerm !== "") {
                this.allInvoices.forEach((invoice) => {
                    if (
                        (invoice.invoice_number &&
                            invoice.invoice_number
                                .toLowerCase()
                                .includes(this.searchTerm.toLowerCase())) ||
                        (invoice.invoice_origin &&
                            invoice.invoice_origin
                                .toLowerCase()
                                .includes(this.searchTerm.toLowerCase())) ||
                        (invoice.payment_terms &&
                            invoice.payment_terms
                                .toLowerCase()
                                .includes(this.searchTerm.toLowerCase())) ||
                        (invoice.reference &&
                            invoice.reference
                                .toLowerCase()
                                .includes(this.searchTerm.toLowerCase())) ||
                        // (invoice.location &&
                        //     invoice.location.name
                        //         .toLowerCase()
                        //         .includes(this.searchTerm.toLowerCase()))
                        (invoice.location_name &&
                            invoice.location_name
                                .toLowerCase()
                                .includes(this.searchTerm.toLowerCase()))
                    ) {
                        filterArr2.push(invoice);
                    }
                });
            }

            if (this.searchStatus !== "all" && this.searchTerm !== "") {
                result = filterArr.filter(
                    (c) => filterArr2.findIndex((x) => x.id == c.id) > -1
                );
            } else if (this.searchStatus !== "all" && this.searchTerm === "") {
                result = filterArr;
            } else if (this.searchStatus === "all" && this.searchTerm !== "") {
                result = filterArr2;
            }

            return result;
        },
        // allInvoicesByPage() {
        //     let invoices = [];
        //     if ( this.pageType == 'dashboard' ) {
        //         if( this.searchAllInvoicesbyTerm.length > 0 ) {
        //             invoices = this.searchAllInvoicesbyTerm.slice(0, 5);
        //         }
        //     } else {
        //         invoices = this.searchAllInvoicesbyTerm;
        //     }
        //     return invoices;
        // }
    },
    mounted() {
        // this.getAllInvoices(this.currentLocation);

        this.store.dispatch("getAllInvoices", {
            location_id: this.currentLocation.id,
            page_type: this.pageType,
        });
    },
    methods: {
        updateRow(val) {
            this.paginatedInvoices = val;
        },
        viewInvoice(invoice) {
            // this.setInvoiceInfo(invoice);
            this.$router.push({
                name: "invoiceInfo",
                params: { id: invoice.id },
            });
        },
        onChange() {
            this.searchInvoices({
                searchTerm: this.searchTerm,
            });
        },
        viewOrder(orderNum, orderId) {
            console.log(orderNum, orderId);
            if (orderNum.substring(0, 2) == "SO") {
                this.$router.push({
                    name: "orderInfo",
                    params: { id: orderId, order_number: orderNum },
                });
            }
        },
    },
};
</script>
